import Typography from '@mui/material/Typography';
import { OutsideLink } from '@openx/components-core/lib/Link/Link.tsx';
import { isUrlValid } from '@openx/utils/lib/isUrlValid.ts';
import { Fragment } from 'react';

type DynamicValueSectionItemCellProps = {
  value: unknown;
  propName?: string;
};

const ellipsisSx = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%',
};

export const DynamicValueSectionItemCell = ({ value, propName }: DynamicValueSectionItemCellProps) => {
  if (Array.isArray(value)) {
    return (
      <Fragment>
        {value.map((v, idx) => (
          <Typography
            key={idx}
            data-test={`dynamic-value-array-${propName ?? 'unknown'}-${String(v)}`}
            variant="body1"
            sx={ellipsisSx}
          >
            {String(v)}
          </Typography>
        ))}
      </Fragment>
    );
  }

  if (typeof value === 'string') {
    const isUrlString = isUrlValid(value);
    return (
      <Typography
        data-test={`dynamic-value-string-${propName ?? 'unknown'}-${value}`}
        variant="body1"
        sx={isUrlString ? ellipsisSx : {}}
      >
        {!isUrlString ? (
          value
        ) : (
          <OutsideLink data-test={`page-link-for-${propName ?? 'unknown'}`} to={value} openInNewTab>
            {value}
          </OutsideLink>
        )}
      </Typography>
    );
  }

  return (
    <Typography
      variant="body1"
      data-test={`dynamic-value-fallback-${propName ?? 'unknown'}-${String(value)}`}
      sx={ellipsisSx}
    >
      {String(value)}
    </Typography>
  );
};
